import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ContentCard from '../../../readingPractice/components/ContentCard/ContentCard';
import { categories } from '../../../readingPractice/constants/categories';

const PracticesGrid = ({ practices, readingCategories, tabType = 'draft' }) => {
  if (!practices || practices.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 6, bgcolor: 'background.paper', borderRadius: 2 }}>
        <Typography color="text.secondary">
          No reading practices are currently available in this collection.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" fontWeight="600" sx={{ mb: 3 }}>
        Reading Practices ({practices.length})
      </Typography>
      <Grid container spacing={3}>
        {practices.map((cover, index) => (
          <Grid item xs={12} sm={6} md={4} key={cover.id || index}>
            <ContentCard
              id={cover.id}
              gradeLevel={cover.gradeLevel}
              thumbnailImageURL={cover.thumbnailUrl}
              title={cover.title}
              category={readingCategories?.find(c => c.id === cover.categoryId)?.name || categories[cover.categoryId] || 'Unknown'}
              synopsis={cover.synopsis}
              onRefresh={() => {}}
              tabType={tabType}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PracticesGrid;
